export default {
    title: 'Publication status',
    publish: 'Publish',
    unpublish: 'Withdraw',
    tooltip: {
        true: 'Withdraw publication of the trend radar',
        false: 'Publish trend radar',
        disabled: 'Status of publication cannot be changed at the moment. There must be at least one evaluation.'
    },
    confirmation: {
        publish: {
            title: 'Publish trend radar',
            intro:
        'Are you sure you want to publish the trend radar? The trend radar is visible for all users  ' +
        'dof the trend manager. The trend radar is published with the following description: ',
            submit: 'Publish',
            evaluationOpen: 'Note: Please note that the rating has not yet been closed. We recommend that you close it before publishing the trend radar.'
        },
        unpublish: {
            title: 'Unpublish trend radar',
            intro: 'There are active sharing options for the trend radar. Are you sure you want to unpublish the trend radar? You will also deactivate the active sharing options.',
            submit: 'Yes, unpublish'
        }
    }
}
